export default {
    document: {
        value: 1,
        title: "Tiedosto",
    },
    link: {
        value: 2,
        title: "Linkki",
    },
};